var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarjeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "26px",
    viewBox: "0 0 33 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.3 Tarjeta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.9Reservaciones-Copy-2",
    transform: "translate(-85.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(68.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-9",
    transform: "translate(0.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.3-Tarjeta",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.478 L0,2.748 C0,1.23 1.23,0 2.748,0 L28.183,0 C29.7,0 30.93,1.23 30.93,2.748 L30.93,20.478 C30.93,21.995 29.7,23.226 28.183,23.226 L2.748,23.226 C1.23,23.226 0,21.995 0,20.478 Z",
    id: "Stroke-1",
    stroke: "#FE8D27",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 5.8787,
    x2: 30.93,
    y2: 5.8787,
    id: "Stroke-3",
    stroke: "#FE8D27",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3918,17.8224 L22.8908,17.8224 C22.4378,17.8224 22.0718,17.4554 22.0718,17.0034 L22.0718,14.5024 C22.0718,14.0494 22.4378,13.6824 22.8908,13.6824 L25.3918,13.6824 C25.8438,13.6824 26.2108,14.0494 26.2108,14.5024 L26.2108,17.0034 C26.2108,17.4554 25.8438,17.8224 25.3918,17.8224",
    id: "Fill-5",
    fill: "#FE8D27"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjeta);
export default __webpack_public_path__ + "static/media/Tarjeta.16b1e767b919642055a41a41a0c421bc.svg";
export { ForwardRef as ReactComponent };